import { render, staticRenderFns } from "./BannerBuilderLayoutSidebar.vue?vue&type=template&id=52b8c793&scoped=true"
import script from "./BannerBuilderLayoutSidebar.vue?vue&type=script&lang=js"
export * from "./BannerBuilderLayoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./BannerBuilderLayoutSidebar.vue?vue&type=style&index=0&id=52b8c793&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8c793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b8c793')) {
      api.createRecord('52b8c793', component.options)
    } else {
      api.reload('52b8c793', component.options)
    }
    module.hot.accept("./BannerBuilderLayoutSidebar.vue?vue&type=template&id=52b8c793&scoped=true", function () {
      api.rerender('52b8c793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/banner-builder/BannerBuilderLayoutSidebar.vue"
export default component.exports